import { gql } from "graphql-tag";

import { getListOfArticles } from "~/slices/ListOfArticles/fragment";
import { getProductCatalogueV2 } from "~/slices/ProductCatalogueV2/fragment";
import { documentLink } from "~/app/prismic/prismic-fragments";

const PAGE_TYPE = "Product_detail_page";

const PRODUCT_DETAIL_PAGE_QUERY = gql`
  query product_detail_page(
    $uid: String!
    $hasBlogTags: Boolean!
    $lazy: Boolean!
    $lang: String = "en-in"
  ) {
    ${PAGE_TYPE}: product_detail_page(uid: $uid, lang: $lang) {
      _linkType
      _meta {
        type
      }
      title
      meta_robots
      comfort_layer
      add_to_cart_text
      add_to_cart_color
      add_to_cart_bg_color
      add_to_cart_font
      find_a_store_content
      payment_icon_document {
        ...documentLink
      }
      anti_tipping_banner
      instore_colors_text
      slices: body {
        ...${PAGE_TYPE}_list_of_articles @include(if: $hasBlogTags)
        ...${PAGE_TYPE}_product_catalogue_v2
      }
    }
  }
  ${getListOfArticles(PAGE_TYPE)}
  ${getProductCatalogueV2(PAGE_TYPE)}
  ${documentLink}
`;

export { PAGE_TYPE, PRODUCT_DETAIL_PAGE_QUERY };
